/** @format */

import React from 'react';
import NumberFormat from 'react-number-format';
import withCartTotalSubscription from './with_cart_total_subscription';

export default withCartTotalSubscription(props => {
    return (
        <React.Fragment>
            <NumberFormat
                style={{padding: 0, top: 0}}
                displayType="text"
                value={props.orderCount}
            />
        </React.Fragment>
    );
});
